import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ConnectedCloudGlyph = /*#__PURE__*/createElement("g", {
  id: "connected_cloud"
}, /*#__PURE__*/createElement("path", {
  d: "M36.9,25c7.3,0,13.3,5.2,14.7,12.1c1.1-0.9,2.5-1.5,4.1-1.5c3.6,0,6.4,2.9,6.4,6.4c0,1.1-0.3,2.2-0.8,3.1 c1.1-0.6,2.3-1,3.6-1c4.1,0,7.4,3.3,7.4,7.4c0,4.1-3.3,7.4-7.4,7.4H19c-4.2-0.5-7.4-4.1-7.4-8.4c0-4.6,3.8-8.4,8.4-8.4 c0.7,0,1.4,0.1,2.1,0.3c-0.1-0.8-0.2-1.6-0.2-2.4C21.9,31.7,28.6,25,36.9,25 M36.9,22c-9.7,0-17.6,7.6-18,17.2 c-5.8,0.5-10.3,5.4-10.3,11.4c0,5.8,4.3,10.7,10,11.4c0.1,0,0.2,0,0.4,0H65c5.7,0,10.4-4.7,10.4-10.4c0-5.7-4.6-10.3-10.3-10.4 c-0.4-4.8-4.5-8.6-9.4-8.6c-0.8,0-1.5,0.1-2.3,0.3C50.6,26.4,44.2,22,36.9,22L36.9,22z"
}), /*#__PURE__*/createElement("path", {
  d: "M36.5,51.2L33,47.6c-0.3-0.3-0.7-0.5-1.1-0.5c-0.4,0-0.8,0.2-1.1,0.5c-0.6,0.6-0.6,1.6,0,2.2l4.6,4.7 c0.3,0.3,0.7,0.5,1.1,0.5s0.8-0.2,1.1-0.5l10.6-10.8c0.6-0.6,0.6-1.6,0-2.2C47.8,41.1,47.4,41,47,41s-0.8,0.2-1.1,0.5L36.5,51.2"
}));
const ConnectedCloud = createSvg({
  name: 'connected_cloud',
  path: ConnectedCloudGlyph
});

export default ConnectedCloud;
export { ConnectedCloudGlyph };
